/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated, do not edit it manually",
 */

import React from "react";

import { smartphoneBrokenOffblack } from "../assets/smartphone-broken-offblack";
import {
  type StaticIllustrativeBaseIconProps,
  StaticIllustrativeIcon,
} from "../static-illustrative-icon";

export const IllustrativeIconSmartphoneBrokenOffblack = (props: StaticIllustrativeBaseIconProps) => (
  <StaticIllustrativeIcon {...props} svg={smartphoneBrokenOffblack.svg} />
);

IllustrativeIconSmartphoneBrokenOffblack.displayName = "IllustrativeIconSmartphoneBrokenOffblack";
